// Mobiele nav — hamburger-toggle voor de sectielinks onder de breakpoint.
// Desktop: links staan inline en de toggle is verborgen (CSS).

export function initNav() {
    const nav = document.querySelector("[data-nav]");
    const toggle = document.querySelector("[data-nav-toggle]");
    if (!nav || !toggle) return;

    const setOpen = (open) => {
        nav.classList.toggle("is-menu-open", open);
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        toggle.setAttribute("aria-label", open ? "Menu sluiten" : "Menu openen");
    };

    toggle.addEventListener("click", () => {
        setOpen(!nav.classList.contains("is-menu-open"));
    });

    // Sluit zodra je een link/CTA in het menu kiest.
    nav.querySelectorAll(".site-nav__link").forEach((link) => {
        link.addEventListener("click", () => setOpen(false));
    });

    // ESC sluit.
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && nav.classList.contains("is-menu-open")) {
            setOpen(false);
            toggle.focus();
        }
    });

    // Terug naar desktop-breedte: reset de open-staat.
    const mq = window.matchMedia("(min-width: 881px)");
    const onChange = () => { if (mq.matches) setOpen(false); };
    mq.addEventListener ? mq.addEventListener("change", onChange) : mq.addListener(onChange);

    // Scroll-aware: transparant over de donkere hero, lichte balk daarna.
    const hero = document.querySelector(".hero");
    const onScroll = () => {
        const threshold = hero ? hero.offsetHeight - 80 : 80;
        nav.classList.toggle("is-scrolled", window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
}
